<template>
  <v-autocomplete
    :items="data"
    item-text="userData.suggestFirstRow"
    v-validate="'required'"
    v-model="model"
    :loading="isLoading"
    :search-input.sync="search"
    :error-messages="errors.collect('address')"
    name="address"
    data-vv-as="Adresa"
    :label="suggestSecondRowInfo()"
    prepend-icon="place"
    browser-autocomplete
    no-data-text
    no-filter
    hide-no-data
    placeholder="Adresa"
    @change="sendData"
    return-object
  >
    <template slot="item" slot-scope="{ item }">
      <v-list-tile-content>
        <v-list-tile-title v-text="item.userData.suggestFirstRow"></v-list-tile-title>
        <v-list-tile-sub-title v-text="item.userData.suggestSecondRow"></v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
import Maps from "@/services/MapsService";
export default {
  props: ["currentLocation"],
  data() {
    return {
      model: null,
      data: [],
      isLoading: false,
      search: "",
      doneTypingInterval: 1000,
      typingTimer: null,
      addressId: 0
    };
  },
  //inject: ["parentValidator"],
  //   created() {
  //     this.$validator = this.parentValidator;
  //   },
  mounted() {
    if (this.currentLocation != null) {
      this.addressId = this.currentLocation.addressId;
      this.model = { userData: {} };
      this.model.userData.suggestFirstRow = this.currentLocation.streetAndNumber;
      this.model.userData.municipality = this.currentLocation.city;
      this.model.userData.zipCode = this.currentLocation.postalCode;
      this.model.userData.district = this.currentLocation.district;
      this.model.userData.region = this.currentLocation.region;
      this.model.userData.country = this.currentLocation.country;
      this.model.userData.latitude = this.currentLocation.latitude;
      this.model.userData.longitude = this.currentLocation.longitude;
      this.data.push(this.model);
    } else {
      this.model = { userData: {} };
    }
  },
  methods: {
    suggestSecondRowInfo() {
      if (this.model == null) {
        return "Adresa";
      }
      return this.model.userData.suggestSecondRow;
    },
    findDestination(val) {
      console.log(val);

      this.isLoading = true;

      new Maps()
        .find(val)
        .then(r => {
          console.log(r.data);
          this.data = r.data.result;
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    sendData() {
      let location = {
        streetAndNumber: this.model.userData.suggestFirstRow,
        city: this.model.userData.municipality,
        postalCode: this.model.userData.zipCode,
        district: this.model.userData.district,
        region: this.model.userData.region,
        country: this.model.userData.country,
        latitude: this.model.userData.latitude,
        longitude: this.model.userData.longitude,
        addressId: this.addressId
      };
      this.$emit("locations", location);
    }
  },
  watch: {
    search(val) {
      if (val == null) {
        this.model = null;
        return;
      }
      if (this.model != null) {
        if (val == this.model.userData.suggestFirstRow) return;
      }

      window.clearTimeout(this.typingTimer);

      this.typingTimer = setTimeout(
        () => this.findDestination(val),
        this.doneTypingInterval
      );
    }
  }
};
</script>
<style>
</style>